import { useState} from 'react'
import { uploadToS3 } from '../../utils/uploadToS3'
import { useMutation } from '@apollo/client'
import { createStyle } from '../../graphql/mutation'
import { getAllTags, getAllPromptsAdmin } from '../../graphql/queries'
import {
  Typography,
  Box,
  Button,
  MenuItem,
  FormControl,
  Select,
  TextField,
  Alert,
  CircularProgress,
  Snackbar,
  Autocomplete,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
} from '@mui/material'
import { useNavigate } from 'react-router-dom'
import ImageUploadField from '../../components/imageUpload';
import { useQuery } from '@apollo/client'
import { designType } from '../../utils/enum'




const toolType = [
  { value: 'IMG2IMG', name: 'IMG2IMG' },
  { value: 'IMG2VIDEO', name: 'IMG2VIDEO' },
  { value: 'IMG2VIDEO_WITH_TEXT', name: 'IMG2VIDEO_WITH_TEXT' },
  { value: 'PREDICT_WITH_MODEL', name: 'PREDICT_WITH_MODEL' },
  { value: 'TEXT2VIDEO', name: 'TEXT2VIDEO' },
  { value: 'TRAIN', name: 'TRAIN' },
  { value: 'VIDEO2VIDEO', name: 'VIDEO2VIDEO' },
]

export default function CreateStylePage() {
  const navigate = useNavigate()

  const [style, setStyle] = useState({
  name: '',
  banner: '',
  secondBanner: '',
  designType: '',
  gifUrl: '',
  webmUrl: '',
  webpUrl: '',
  rowNumber: '',
  videoUrl: '',
  isFuture: false,
  isPublic: false,
  tagIds: [],
  highlighted: false,
  promptIds: [],
  toolType: '',
})

  const [file, setFile] = useState(null)
  const [video, setVideo] = useState(null)
  const [gif, setGif] = useState(null)
  const [webmFile, setWebmFile] = useState(null)
  const [webpFile, setWebpFile] = useState(null)
  const [secondBannerFile, setSecondBannerFile] = useState(null)
  const [progress, setProgress] = useState(false)
  const [openImageModal, setOpenImageModal] = useState(false)
  const [modalImageSrc, setModalImageSrc] = useState('')
  const [snackBarOpen,setSnackBarOpen] = useState(false)
  const [snackBarMessage,setSnackBarMessge] = useState(null)
  const [snackBarSeverity, setSnackBarSeverity] = useState('success')
  const [selectedTags, setSelectedTags] = useState([])
  const [selectedPrompts, setSelectedPrompts] = useState([])
  const [promptSearchTerm, setPromptSearchTerm] = useState('')
  const handleChange = (e) => {
    const { name, value } = e.target
    setStyle((prev) => ({ ...prev, [name]: value }))
    
    // If toolType changes, clear selected prompts as they might not be compatible
    if (name === 'toolType') {
      setSelectedPrompts([])
      setStyle((prev) => ({ ...prev, promptIds: [] }))
    }
  }

  const handleBannerFileSelected = (e) => {
  const selectedFile = e.target.files[0]
  setFile(selectedFile)
  }

  const handleVideoSelected = (e) => {
    const selectedFile = e.target.files[0]
    setVideo(selectedFile)
  }

  const handleGifSelected = (e) => {
    const selectedFile = e.target.files[0]
    setGif(selectedFile)
  }

  const handleWebmSelected = (e) => {
    const selectedFile = e.target.files[0]
    setWebmFile(selectedFile)
  }

  const handleWebpSelected = (e) => {
    const selectedFile = e.target.files[0]
    setWebpFile(selectedFile)
  }

  const handleSecondBannerSelected = (e) => {
    const selectedFile = e.target.files[0]
    setSecondBannerFile(selectedFile)
  }

  const handleImageClick = (src) => {
    setModalImageSrc(src);
    setOpenImageModal(true);
  };

  const handlePromptCheckboxChange = (prompt, checked) => {
    if (checked) {
      setSelectedPrompts(prev => [...prev, prompt])
      setStyle(prev => ({
        ...prev,
        promptIds: [...prev.promptIds, prompt.id]
      }))
    } else {
      setSelectedPrompts(prev => prev.filter(p => p.id !== prompt.id))
      setStyle(prev => ({
        ...prev,
        promptIds: prev.promptIds.filter(id => id !== prompt.id)
      }))
    }
  }

  const [createStyleMutation] = useMutation(createStyle)

  const { data: tagsData } = useQuery(getAllTags)
  const tags = tagsData?.getAllTags || []

  const { data: promptsData, loading: promptsLoading } = useQuery(getAllPromptsAdmin, {
    variables: { page: 1, pageSize: 1000 }
  })

  const prompts = promptsData?.getAllPromptsAdmin?.prompts || []
  
  // Filter prompts based on selected toolType and search term
  const filteredPrompts = prompts.filter(prompt => {
    const matchesToolType = !style.toolType || prompt.toolType === style.toolType
    const matchesSearch = !promptSearchTerm || 
      prompt.prompt?.toLowerCase().includes(promptSearchTerm.toLowerCase()) ||
      prompt.Style?.name?.toLowerCase().includes(promptSearchTerm.toLowerCase()) ||
      prompt.gender?.toLowerCase().includes(promptSearchTerm.toLowerCase())
    return matchesToolType && matchesSearch
  }).sort((a, b) => {
    // Show selected items first
    const aSelected = selectedPrompts.some(p => p.id === a.id)
    const bSelected = selectedPrompts.some(p => p.id === b.id)
    if (aSelected && !bSelected) return -1
    if (!aSelected && bSelected) return 1
    return 0
  })

  const handleCreateStyle = async () => {

  if (!style.name || !style.designType) {
    setSnackBarMessge('Please fill in all required fields.');
    setSnackBarSeverity('error')
    setSnackBarOpen(true);
    return;
  }
    setProgress(true)
    try{
    const s3VideoFile = video ? await uploadToS3(video) : ''
    const s3ThumbnailFile = file ? await uploadToS3(file, 'img') : ''
    const s3GifFile = gif ? await uploadToS3(gif, 'gif') : ''
    const s3WebmFile = webmFile ? await uploadToS3(webmFile, 'video') : ''
    const s3WebpFile = webpFile ? await uploadToS3(webpFile, 'img') : ''
    const s3SecondBannerFile = secondBannerFile ? await uploadToS3(secondBannerFile, 'img') : ''

    const gpqResponse = await createStyleMutation({
      variables: {
        name: style.name,
        banner: s3ThumbnailFile,
        secondBanner: s3SecondBannerFile,
        designType: style.designType,
        rowNumber: 1,
        isFuture: false,
        isPublic: false,
        videoUrl:s3VideoFile,
        gifUrl:s3GifFile,
        webmUrl:s3WebmFile,
        webpUrl:s3WebpFile,
        tagIds: style.tagIds,
        highlighted: false,
        promptIds: style.promptIds,
        toolType: style.toolType,
      },
    })
    setProgress(false)
    if (gpqResponse.data) {
      setSnackBarMessge('Style created successfully')
      setSnackBarOpen(true)
      setSnackBarSeverity('success')
        setTimeout(() => {
        navigate('/styles');
      }, 1000);
    }else{
      setSnackBarMessge('Create failed')
      setSnackBarOpen(true)
      setSnackBarSeverity('error')
    }
  } catch(error){
      console.error('Error creating style:', error);
      setSnackBarMessge(`Create failed: ${error.message}`);
      setSnackBarSeverity('error');
      setSnackBarOpen(true);
    } finally {
      setProgress(false);
    }
  }

  const handleSnackBarClose=()=>{
  setSnackBarOpen(false)
}


  return (
    <Box>
      <Snackbar
        open={snackBarOpen}
        autoHideDuration={3000}
        onClose={handleSnackBarClose}
        message={snackBarMessage}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
            <Alert 
            onClose={handleSnackBarClose} 
            severity={snackBarSeverity} 
            sx={{ width: '100%' }}
          >
            {snackBarMessage}
          </Alert>
      </Snackbar>

      {/* Sticky Header with Actions */}
      <Box 
        sx={{ 
          position: 'sticky',
          top: 0,
          zIndex: 1000,
          backgroundColor: 'white',
          borderBottom: '1px solid #e9ecef',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 4, flexWrap: 'wrap', gap: 2 }}>
          <Typography variant='h4' sx={{color:'#212529',fontWeight:'bold' }}>
            Create Style
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={handleCreateStyle}
            sx={{ 
              borderRadius: 2,
              px: 4,
              backgroundColor: '#3498db',
              '&:hover': { backgroundColor: '#2980b9' }
            }}
          >
            Save Style
          </Button>
        </Box>
      </Box>
      {progress && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(255,255,255,0.7)',
            zIndex: 1300,
          }}
        >
          <CircularProgress size={80} thickness={5} />
        </Box>
      )}

    {/* Main Content Container */}
    <Box sx={{ maxWidth: '1400px', mx: 'auto', px: { xs: 2, md: 4 } }}>
      {/* Basic Information Section */}
      <Paper sx={{ p: 4, mb: 4, borderRadius: 3, boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
        <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold', color: '#2c3e50', borderBottom: '2px solid #3498db', pb: 1 }}>
          Basic Information
        </Typography>
        
        <Box sx={{ mb: 3 }}>
          <TextField
            fullWidth
            label="Style Name"
            variant="outlined"
            name="name"
            value={style?.name ?? ''}
            onChange={handleChange}
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          />
        </Box>

        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 3 }}>
          <FormControl fullWidth>
            <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: '#34495e' }}>Design Type</Typography>
            <Select 
              name="designType" 
              onChange={handleChange} 
              value={style?.designType ?? ''}
              sx={{ borderRadius: 2 }}
            >
              {designType.map(i => (
                <MenuItem key={i.name} value={i.name}>
                  {i.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          
          <FormControl fullWidth>
            <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: '#34495e' }}>Tool Type</Typography>
            <Select 
              name="toolType" 
              onChange={handleChange} 
              value={style?.toolType ?? ''}
              sx={{ borderRadius: 2 }}
            >
              {toolType.map(i => (
                <MenuItem key={i.name} value={i.name}>
                  {i.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Paper>

      {/* Tags Section */}
      <Paper sx={{ p: 4, mb: 4, borderRadius: 3, boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
        <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold', color: '#2c3e50', borderBottom: '2px solid #e74c3c', pb: 1 }}>
          Tags
        </Typography>
        
        <Box>
          <Typography variant="body2" sx={{ mb: 2, fontWeight: 500, color: '#34495e' }}>Select Tags</Typography>
          <Autocomplete
            multiple
            options={tags}
            getOptionLabel={(option) => option.name}
            value={selectedTags}
            onChange={(event, newValue) => {
              setSelectedTags(newValue)
              setStyle(prev => ({
                ...prev,
                tagIds: newValue.map(tag => tag.id)
              }))
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                placeholder="Select tags..."
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
              />
            )}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  {...getTagProps({ index })}
                  key={option.id}
                  label={option.name}
                  size="small"
                  sx={{ 
                    backgroundColor: '#3498db', 
                    color: 'white',
                    '& .MuiChip-deleteIcon': { color: 'white' }
                  }}
                />
              ))
            }
          />
        </Box>
      </Paper>

      {/* Media Section */}
      <Paper sx={{ p: 4, mb: 4, borderRadius: 3, boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
        <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold', color: '#2c3e50', borderBottom: '2px solid #9b59b6', pb: 1 }}>
          Media Assets
        </Typography>
        
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', lg: '1fr 1fr 1fr' }, gap: 4 }}>
          <Box>
            <ImageUploadField
              label="Thumbnail"
              file={file}
              imageUrl={''}
              inputName="thumbnail"
              onImageClick={handleImageClick}
              onImageChange={handleBannerFileSelected}
              onDelete={() => {
                setFile(null)
                setStyle(prev => ({ ...prev, banner: '' }));
              }}
            />
          </Box>

          <Box>
            <ImageUploadField
              label="Video"
              inputName="video"
              imageUrl={''}
              isVideo
              file={video}
              onImageClick={handleImageClick}
              onImageChange={handleVideoSelected}
              onDelete={() => {
                setVideo(null)
                setStyle(prev => ({ ...prev, video: '' }));
              }}
            />
          </Box>

          <Box>
            <ImageUploadField
              label="GIF"
              inputName="gif"
              imageUrl={''}
              file={gif}
              isVideo
              onImageClick={handleImageClick}
              onImageChange={handleGifSelected}
              onDelete={() => {
                setGif(null)
                setStyle(prev => ({ ...prev, gifUrl: '' }));
              }}
            />
          </Box>
        </Box>
        
        {/* Additional Media Assets Row */}
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', lg: '1fr 1fr 1fr' }, gap: 4, mt: 4 }}>
          <Box>
            <ImageUploadField
              label="WEBM Video"
              file={webmFile}
              imageUrl={''}
              inputName="webm"
              isVideo
              onImageClick={handleImageClick}
              onImageChange={handleWebmSelected}
              onDelete={() => {
                setWebmFile(null)
                setStyle(prev => ({ ...prev, webmUrl: '' }));
              }}
            />
          </Box>
          
          <Box>
            <ImageUploadField
              label="WEBP Image"
              file={webpFile}
              imageUrl={''}
              inputName="webp"
              onImageClick={handleImageClick}
              onImageChange={handleWebpSelected}
              onDelete={() => {
                setWebpFile(null)
                setStyle(prev => ({ ...prev, webpUrl: '' }));
              }}
            />
          </Box>

          <Box>
            <ImageUploadField
              label="Second Banner"
              file={secondBannerFile}
              imageUrl={''}
              inputName="secondBanner"
              onImageClick={handleImageClick}
              onImageChange={handleSecondBannerSelected}
              onDelete={() => {
                setSecondBannerFile(null)
                setStyle(prev => ({ ...prev, secondBanner: '' }));
              }}
            />
          </Box>
        </Box>
      </Paper>
    </Box>



  {/* Prompts Selection Section */}
  {style.toolType && (
    <Box sx={{ maxWidth: '1400px', mx: 'auto', px: { xs: 2, md: 4 }, mb: 4 }}>
      <Paper sx={{ p: 4, borderRadius: 3, boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
        <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold', color: '#2c3e50', borderBottom: '2px solid #f39c12', pb: 1 }}>
          Available Prompts ({style.toolType})
        </Typography>

        {/* Selected Prompts Display */}
        {selectedPrompts.length > 0 && (
          <Box sx={{ mb: 4, p: 3, backgroundColor: '#f8f9fa', borderRadius: 2, border: '1px solid #e9ecef' }}>
            <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600, color: '#2c3e50' }}>
              Selected Prompts ({selectedPrompts.length})
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5 }}>
              {selectedPrompts.map((prompt) => (
                <Chip
                  key={prompt.id}
                  label={prompt.name || (prompt.prompt?.length > 40 ? prompt.prompt.substring(0, 40) + '...' : prompt.prompt)}
                  onDelete={() => handlePromptCheckboxChange(prompt, false)}
                  variant="filled"
                  size="medium"
                  sx={{ 
                    backgroundColor: '#f39c12', 
                    color: 'white',
                    fontWeight: 500,
                    '& .MuiChip-deleteIcon': { 
                      color: 'white',
                      '&:hover': { color: '#ecf0f1' }
                    }
                  }}
                />
              ))}
            </Box>
          </Box>
        )}
        
        {/* Prompts Search Bar */}
        <TextField
          fullWidth
          placeholder="Search prompts by text, style, or gender..."
          value={promptSearchTerm}
          onChange={(e) => setPromptSearchTerm(e.target.value)}
          sx={{ 
            mb: 3,
            '& .MuiOutlinedInput-root': { 
              borderRadius: 2,
              backgroundColor: '#f8f9fa'
            }
          }}
          InputProps={{
            sx: { fontSize: '0.95rem' }
          }}
        />
        
        <TableContainer 
          component={Paper} 
          sx={{ 
            maxHeight: 500, 
            borderRadius: 2,
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
            border: '1px solid #e9ecef'
          }}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell 
                  padding="checkbox"
                  sx={{ backgroundColor: '#f8f9fa', fontWeight: 600 }}
                >
                  Select
                </TableCell>
                <TableCell sx={{ backgroundColor: '#f8f9fa', fontWeight: 600 }}>
                  Banner
                </TableCell>
                <TableCell sx={{ backgroundColor: '#f8f9fa', fontWeight: 600 }}>
                  Prompt
                </TableCell>
                <TableCell sx={{ backgroundColor: '#f8f9fa', fontWeight: 600 }}>
                  Style
                </TableCell>
                <TableCell sx={{ backgroundColor: '#f8f9fa', fontWeight: 600 }}>
                  Gender
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {promptsLoading ? (
                <TableRow>
                  <TableCell colSpan={5} align="center" sx={{ py: 4 }}>
                    <CircularProgress size={30} sx={{ color: '#3498db' }} />
                    <Typography variant="body2" sx={{ mt: 2, color: '#7f8c8d' }}>
                      Loading prompts...
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : filteredPrompts.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={5} align="center" sx={{ py: 4 }}>
                    <Typography variant="body1" color="text.secondary" sx={{ fontWeight: 500 }}>
                      {style.toolType ? `No prompts found for ${style.toolType}` : 'Select a tool type to see available prompts'}
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                filteredPrompts.map((prompt) => {
                  const isSelected = selectedPrompts.some(p => p.id === prompt.id)
                  return (
                    <TableRow 
                      key={prompt.id} 
                      hover 
                      sx={{ 
                        '&:hover': { backgroundColor: '#f8f9fa' },
                        backgroundColor: isSelected ? '#e3f2fd' : 'inherit'
                      }}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={isSelected}
                          onChange={(e) => handlePromptCheckboxChange(prompt, e.target.checked)}
                          sx={{ 
                            color: '#3498db',
                            '&.Mui-checked': { color: '#3498db' }
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        {prompt.banner ? (
                          <Box
                            component="img"
                            src={prompt.banner}
                            alt="Prompt banner"
                            sx={{
                              width: 50,
                              height: 50,
                              borderRadius: 2,
                              objectFit: 'cover',
                              border: '1px solid #e9ecef',
                              cursor: 'pointer',
                              '&:hover': { transform: 'scale(1.05)' },
                              transition: 'transform 0.2s ease'
                            }}
                            onClick={() => handleImageClick(prompt.banner)}
                          />
                        ) : (
                          <Box
                            sx={{
                              width: 50,
                              height: 50,
                              backgroundColor: '#f5f5f5',
                              borderRadius: 2,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              border: '1px solid #e9ecef',
                            }}
                          >
                            <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem' }}>
                              No Image
                            </Typography>
                          </Box>
                        )}
                      </TableCell>
                      <TableCell sx={{ maxWidth: 250 }}>
                        <Typography variant="body2" sx={{ lineHeight: 1.4 }}>
                          {prompt.prompt?.length > 80 ? prompt.prompt.substring(0, 80) + '...' : prompt.prompt}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" sx={{ fontWeight: 500, color: '#2c3e50' }}>
                          {prompt.Style?.name || 'No Style'}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Chip 
                          label={prompt.gender || 'N/A'} 
                          size="small"
                          variant="outlined"
                          sx={{ 
                            borderColor: '#3498db',
                            color: '#3498db',
                            fontWeight: 500
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  )
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  )}
  {openImageModal && (
    <Box
      onClick={() => setOpenImageModal(false)}
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0,0,0,0.7)',
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <img
        src={modalImageSrc}
        alt="Full Preview"
        style={{
          maxWidth: '90%',
          maxHeight: '90%',
          objectFit: 'contain',
          borderRadius: '10px',
        }}
        onClick={e => e.stopPropagation()} 
      />
    </Box>
  )}
</Box>
  )
}
